<template>
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
    <div class="columns">
      <div class="column">
        <!-- 약관 설정 -->
        <div class="box">
          <admin-box-item title="약관 설정"
                          subtitle="서비스 약관정보를 입력하고 수정할 수 있습니다."
                          :titleFlex="true"
                          :useTab="false">

            <div class="columns">
              <div class="column">
                <admin-form-item>
                  <!--<textarea class="textarea" v-model="policy.limit"></textarea>-->
                  <lp-editor :text.sync="policy.limit"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 개인정보 처리방침 설정 -->
        <div class="box">
          <admin-box-item title="개인정보 처리방침 설정"
                          subtitle="개인정보 처리방침을 입력하고 수정할 수 있습니다."
                          :titleFlex="true"
                          :useTab="false">

            <div class="columns">
              <div class="column">
                <admin-form-item>
                  <!--<textarea class="textarea" v-model="policy.term"></textarea>-->
                  <lp-editor :text.sync="policy.term"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 전자거래 이용약관 설정 -->
        <div class="box">
          <admin-box-item title="전자 거래 이용약관 설정"
                          subtitle="전자거래 이용약관을 입력하고 수정할 수 있습니다."
                          :titleFlex="true"
                          :useTab="false">

            <div class="columns">
              <div class="column">
                <admin-form-item>
                  <!--<textarea class="textarea" v-model="policy.trans"></textarea>-->
                  <lp-editor :text.sync="policy.trans"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 호스팅 이용약관 -->
        <div class="box">
          <admin-box-item title="호스팅 이용약관 설정"
                          subtitle="호스팅 이용약관을 입력하고 수정할 수 있습니다."
                          :titleFlex="true"
                          :useTab="false">

            <div class="columns">
              <div class="column">
                <admin-form-item>
                  <!--<textarea class="textarea" v-model="policy.hosting"></textarea>-->
                  <lp-editor :text.sync="policy.hosting"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 파트너 개인정보 처리방침 -->
        <div class="box" v-if="isInternalPlugin('partner_inquiry')">
          <admin-box-item title="파트너입점 신청/문의 전용 개인정보 처리 방침 설정"
                          subtitle="개인정보 처리방침을 입력하고 수정할 수 있습니다."
                          :useTab="false">

            <div class="columns">
              <div class="column">
                <admin-form-item>
                  <lp-editor :text.sync="policy.partner_privacy"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 디지털 콘텐츠약관 설정 -->
        <div class="box" v-if="isLaunchpack">
          <admin-box-item title="디지털 콘텐츠약관 설정"
                          subtitle="디지털 콘텐츠약관을 입력하고 수정할 수 있습니다."
                          :titleFlex="true"
                          :useTab="false">

            <div class="columns">
              <div class="column">
                <admin-form-item>
                  <!--<textarea class="textarea" v-model="policy.digital"></textarea>-->
                  <lp-editor :text.sync="policy.digital"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 제3자 정보제공 동의 -->
        <div class="box" v-if="isLaunchpack">
          <admin-box-item title="제3자 정보제공 동의"
                          subtitle="고객의 개인정보를 받아서 파트너에게 제공하는
                          경우에 필요한 제3자 정보제공방침을 입력하고 수정할 수 있습니다."
                          :titleFlex="true"
                          :useTab="false">

            <div class="columns">
              <div class="column">
                <admin-form-item>
                  <!--<textarea class="textarea" v-model="policy.third"></textarea>-->
                  <lp-editor :text.sync="policy.third"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 위치기반 서비스 약관 -->
        <div class="box">
          <admin-box-item title="위치기반 서비스 약관"
                          subtitle="고객의 위치정보를 받아서 파트너에게 제공하는
                          경우에 필요한 위치기반 서비스을 입력하고 수정할 수 있습니다."
                          :titleFlex="true"
                          :useTab="false">

            <div class="columns">
              <div class="column">
                <admin-form-item>
                  <!--<textarea class="textarea" v-model="policy.localterm"></textarea>-->
                  <lp-editor :text.sync="policy.localterm"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 마케팅 활용 동의 -->
        <div class="box">
          <admin-box-item title="마케팅 활용 동의 설정"
                          subtitle="마케팅 활용 동의를 입력하고 수정할 수 있습니다."
                          :titleFlex="true"
                          :useTab="false">

            <div class="columns">
              <div class="column">
                <admin-form-item>
                  <!--<textarea class="textarea" v-model="policy.marketing"></textarea>-->
                  <lp-editor :text.sync="policy.marketing"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

      </div>
    </div>

    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

  </div>
</template>

<script>
  export default {
    layout: 'Main',
    created() {
      this.$axios.get('admin/service/policy').then(res => {
        if(res.status === 200) {
          let policy = res.data.policy;

          if(!policy.partner_privacy) {
            policy.partner_privacy = '';
          }

          this.policy = policy;
        }
      });

      this.getPackages();
    },
    data () {
      return {
        policy: {
          limit: '',          // 약관설정
          term: '',           // 개인정보 처리방침
          trans: '',          // 전자거래 이용약관
          hosting: '',        // 호스팅 이용약관
          digital: '',        // 디지털 콘텐츠 약관
          third: '',          // 제3자 정보제공
          localterm: '',      // 위치기반 서비스 약관
          marketing: '',      // 마케팅 활용 동의
        },
        packages:[]
      }
    },
    computed: {
      isLaunchpack(){
        if (this.packages[0].name==='launchpack') return true;
        else return false;
      },
    },
    methods: {
      save() {
        this.$axios.patch('admin/service/policy', {policy: this.policy})
          .then(res => {
            this.toast('약관 및 개인정보 처리방침 설정이 저장되었습니다.');
            this.saveServiceGuide('policy')
          });
      },
      getPackages(){
        this.packages = this.$store.getters.getPackages;
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
//@import '~assets/css/reset'
//@import '~assets/css/lp_main'

</style>
